import { MARQUEE_ITEMS } from "@/data/services";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee-ribbon"
      className="relative border-y border-white/10 bg-ark-900/60 py-5 overflow-hidden"
    >
      <div className="flex w-max animate-marquee">
        {items.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-mono text-xs tracking-[0.35em] text-slate-400 uppercase px-8">
              {item}
            </span>
            <span className="text-cyan-400/60 text-[10px]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
